var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/// <reference types="vite/client" />
import { assertExists } from '@blocksuite/global/utils';
import { BlockElement } from '@blocksuite/lit';
import { css, html, render } from 'lit';
import { customElement } from 'lit/decorators.js';
import { matchFlavours } from '../_common/utils/index.js';
import { AffineDragHandleWidget } from '../page-block/widgets/drag-handle/drag-handle.js';
import { captureEventTarget } from '../page-block/widgets/drag-handle/utils.js';
import { KeymapController } from './keymap-controller.js';
import { NoteBlockSchema } from './note-model.js';
let NoteBlockComponent = class NoteBlockComponent extends BlockElement {
    constructor() {
        super(...arguments);
        this.keymapController = new KeymapController(this);
        this._dragHandleOption = {
            flavour: NoteBlockSchema.model.flavour,
            edgeless: true,
            onDragStart: ({ state, startDragging, anchorBlockPath }) => {
                if (!anchorBlockPath)
                    return false;
                const element = captureEventTarget(state.raw.target);
                const insideDragHandle = !!element?.closest('affine-drag-handle-widget');
                if (!insideDragHandle)
                    return false;
                const anchorComponent = this.std.view.viewFromPath('block', anchorBlockPath);
                if (!anchorComponent ||
                    !matchFlavours(anchorComponent.model, [NoteBlockSchema.model.flavour]))
                    return false;
                const noteComponent = anchorComponent;
                const notePortal = noteComponent.closest('.edgeless-block-portal-note');
                assertExists(notePortal);
                const dragPreviewEl = notePortal.cloneNode();
                dragPreviewEl.style.transform = '';
                const noteBackground = notePortal.querySelector('.note-background');
                assertExists(noteBackground);
                const noteBackgroundClone = noteBackground.cloneNode();
                dragPreviewEl.appendChild(noteBackgroundClone);
                const container = document.createElement('div');
                container.style.width = '100%';
                container.style.height = '100%';
                container.style.overflow = 'hidden';
                dragPreviewEl.appendChild(container);
                render(noteComponent.host.renderModel(noteComponent.model), container);
                startDragging([noteComponent], state, dragPreviewEl);
                return true;
            },
            onDragEnd: ({ draggingElements, dropBlockId, dropType }) => {
                if (draggingElements.length !== 1 ||
                    !matchFlavours(draggingElements[0].model, [
                        NoteBlockSchema.model.flavour,
                    ])) {
                    return false;
                }
                if (dropType === 'in')
                    return true;
                const noteBlock = draggingElements[0].model;
                const targetBlock = this.page.getBlockById(dropBlockId);
                const parentBlock = this.page.getParent(dropBlockId);
                if (!targetBlock || !parentBlock)
                    return true;
                this.page.moveBlocks(noteBlock.children, parentBlock, targetBlock, dropType === 'before');
                this.page.deleteBlock(noteBlock);
                return true;
            },
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.keymapController.bind();
        this.disposables.add(AffineDragHandleWidget.registerOption(this._dragHandleOption));
    }
    render() {
        return html `
      <div class="affine-note-block-container">
        <div class="affine-block-children-container">
          ${this.renderModelChildren(this.model)}
        </div>
      </div>
    `;
    }
};
NoteBlockComponent.styles = css `
    .affine-note-block-container {
      display: flow-root;
      position: relative;
    }
    .affine-note-block-container.selected {
      background-color: var(--affine-hover-color);
    }
  `;
NoteBlockComponent = __decorate([
    customElement('affine-note')
], NoteBlockComponent);
export { NoteBlockComponent };
//# sourceMappingURL=note-block.js.map